import { HocuspocusProvider } from "@hocuspocus/provider";

import { firebaseAuth } from "@/utils/firebaseAuth";
import { getMobileBridgeIdToken, isInsideMobileWebView } from "@/utils/mobileBridgeAuth";

import type * as Y from "yjs";

const getToken = () => {
  if (firebaseAuth) {
    return async () => {
      try {
        if (isInsideMobileWebView()) {
          const bridgeToken = await getMobileBridgeIdToken();
          if (bridgeToken) return bridgeToken;
        } else if (firebaseAuth.currentUser) {
          return await firebaseAuth.currentUser.getIdToken();
        }
      } catch (e: unknown) {
        console.warn("Failed to fetch firebase token", e);
        throw new Error("auth-token-fetch-failed");
      }
      return "no-token";
    };
  }
  // We need to send some token even if there is no token, because HocuspocusProvider requires
  // token if onAuthenticate hook is used
  // https://github.com/ueberdosis/hocuspocus/blob/4defd269217435848dd582cdaab60b386056c95c/docs/server/hooks.md
  // @see apps/yjs-api/src/authenticate.ts
  return "no-token";
};

export function getWebSocketUrl(pathOrUrl?: string) {
  if (
    !pathOrUrl ||
    typeof window === "undefined" ||
    !window.location ||
    pathOrUrl.startsWith("ws://") ||
    pathOrUrl.startsWith("wss://")
  ) {
    return pathOrUrl;
  }

  const { host } = window.location;
  const isHttps = window.location.protocol === "https:";
  const wsProtocol = isHttps ? "wss" : "ws";

  let path = pathOrUrl;
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }

  return `${wsProtocol}://${host}${path}`;
}

export function getYjsProvider(name: string, document: Y.Doc) {
  const token = getToken();
  const websocketUrl = getWebSocketUrl("/yjs")!;

  return new HocuspocusProvider({
    url: websocketUrl,
    name,
    document,
    token,
  });
}
